import AlertModal from '../functions/AlertModal';
import Alert from '../functions/Alert';

export default class ProductChecked {

    constructor() {
        this.classSelected = 'Polaris-Tabs__Tab--active';
        this.$content = null;
        this.alertModal = new AlertModal();
        this.alert = new Alert();
        this.activeRequests = [];
        this.editors = [];

        this.onChangeContent = this.onChangeContent.bind(this);
        this.onUpdatePhraseSubmit = this.onUpdatePhraseSubmit.bind(this);
        this.onFilterSubmit = this.onFilterSubmit.bind(this);
        this.onFilteredValuesClick = this.onFilteredValuesClick.bind(this);
        this.onPaginatorLinkClick = this.onPaginatorLinkClick.bind(this);
        this.onApproveClick = this.onApproveClick.bind(this);
        this.onReloadItemClick = this.onReloadItemClick.bind(this);
        this.onTextFormSubmit = this.onTextFormSubmit.bind(this);
        this.onTextAreaType = this.onTextAreaType.bind(this);
        this.onSortClick = this.onSortClick.bind(this);
        this.checkLastItemApproved = this.checkLastItemApproved.bind(this);
        this.onPageLimitBtnClick = this.onPageLimitBtnClick.bind(this);
        this.onUrlSaveSubmit = this.onUrlSaveSubmit.bind(this);
        this.loadItems = this.loadItems.bind(this);
        this.abortActiveRequests = this.abortActiveRequests.bind(this);
        this.removeFromActiveRequests = this.removeFromActiveRequests.bind(this);
        this.initCkEditor = this.initCkEditor.bind(this);
        this.destroyEditors = this.destroyEditors.bind(this);
        this.synchronizeFilterHash = this.synchronizeFilterHash.bind(this);
        this.loadOneItem = this.loadOneItem.bind(this);
        this.reloadOneItem = this.reloadOneItem.bind(this);
        this.clearCacheForItem = this.clearCacheForItem.bind(this);
    }

    init() {
        this.$content = $('[data-product-check-tab-content]');
        $(document).on('click', 'a[data-ajax-content-selector]', this.onChangeContent);
        $(document).on('submit', 'form[data-form-name="update-phrase-modal"]', this.onUpdatePhraseSubmit);
        $(document).on('submit', '[data-list-filter]', this.onFilterSubmit);
        $(document).on('click', '[data-filtered-values] a', this.onFilteredValuesClick);
        $(document).on('click', '[data-paginator] a', this.onPaginatorLinkClick);
        $(document).on('click', '[data-list-page-limit]', this.onPageLimitBtnClick);
        $(document).on('click', '[data-approve-btn]', this.onApproveClick);
        $(document).on('click', '[data-reload-item]', this.onReloadItemClick);
        $(document).on('submit', '[data-text-form]', this.onTextFormSubmit);
        $(document).on('input', '[data-text-form] input', this.onTextAreaType);
        $(document).on('click', '[data-sort] a', this.onSortClick);
        $(document).on('click', '[data-url-save]', this.onUrlSaveSubmit);
        $(document).on('click', '[data-reload-item]', this.reloadOneItem);

        $('[data-ajax-content-selector].' + this.classSelected).trigger('click');
        this.updateUrlCount();
    }

    updateUrlCount() {
        let href = $('.tab-count-url').data('href-url-count');
        $.ajax({
            url: href,
            type: 'GET',
            success: (response) => {
                $('.tab-count-url').html(response.url_count);
            }, error: (jqXHR, textStatus, errorThrown) => {
                console.error('Error: ' + errorThrown);
            }
        });
    }

    onUrlSaveSubmit(e) {
        e.preventDefault();
        let $content = $(e.currentTarget).closest('[data-url-content]')
        let $elm = $content.find('[data-action]');
        let action = $elm.data('action');
        let data = {
            url: $elm.val(),
            default_url: $elm.data('default-value'),
            product_langs: $elm.data('translated-product-url-input'),
            attribute: $elm.data('translated-product-url-attribute'),
        };

        $.ajax({
            url: action,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            data: data,
            success: (response) => {
                if (response.status === 'error') {
                    this.alertModal.show(response.message, 'Error');
                } else {
                    window.alert(response.message);
                    if ($elm.data('check') === 0) {
                        $content.remove();
                    }
                }
            }
        });
    }

    onTextAreaType(e) {

        let $this = $(e.currentTarget ?? e);
        let $form = $this.closest('form');
        let $btn = $form.find('button[type="submit"]');
        let $btnApprove = $form.find('[data-approve-btn]');
        let $checkbox = $form.find('[data-approve-lock]');
        $btn.removeAttr('disabled').removeClass('Polaris-Button--disabled');
        $btnApprove.attr('disabled', true).addClass('Polaris-Button--disabled');
        $checkbox.attr('disabled', true).addClass('Polaris-Button--disabled');

        // budu si pamatovat, které elementy byly editovány, abych je mohl na serveru ulozit - neukladam teda vsechno
        let name = $this.attr('name');
        let langElementEditedInput = $form.find('input[name="lang_elements_edited"]');
        let langElementEditedInputValues = langElementEditedInput.val().split(',');
        if (!langElementEditedInputValues.includes(name)) {
            langElementEditedInputValues.push(name);
        }
        langElementEditedInput.val(langElementEditedInputValues.join(','));
    }

    onTextFormSubmit(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let langId = $this.find('input[name="lang_id"]').val();

        let re = new RegExp('lang_element_.+_' + langId);
        for (let key in this.editors) {
            if (re.test(key)) {
                let dataEditor = this.editors[key].getData();
                let testareaName = key.replace(/\_\d+$/, "");
                $this.find('#' + testareaName).val(dataEditor);
            }
        }

        let data = $this.serialize();
        let url = $this.attr('action');
        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            success: (response) => {
                if (response.status === 'error') {
                    this.alertModal.show(response.message, 'Error');
                } else {
                    $this.find('[data-text-form-submit]').attr('disabled', true).addClass('Polaris-Button--disabled');
                    $this.find('[data-approve-btn]').removeAttr('disabled').removeClass('Polaris-Button--disabled');
                    $this.find('[data-approve-lock]').removeAttr('disabled').removeClass('Polaris-Button--disabled');
                    window.alert(response.msg);
                }
            }
        })
    }

    destroyEditors($form) {
        let langId = $form.find('input[name="lang_id"]').val();
        let re = new RegExp('lang_element_.+_' + langId);
        for (let key in this.editors) {
            if (re.test(key)) {
                this.editors[key].destroy();
                delete this.editors[key];
            }
        }
    }

    onReloadItemClick(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $item = $this.closest('[data-item-card]');
        let url = $this.attr('href');

        if (url.indexOf('phrase') !== -1) { // menim z editace zpět na zobrazení
            this.destroyEditors($this.closest('form'));
        }

        $this.hide();
        $this.append('<img width="15" height="15" src="/images/ajax-loader.gif" />');
        $.ajax({
            url: url,
            type: 'GET',
            success: (response) => {
                if (response.status === 'error') {
                    this.alertModal.show(response.message, 'Error');
                    $this.show();
                } else {
                    $item.html(response.html);
                    initAutoheight();
                    let editors = this.initCkEditor();
                }
            }, complete: () => {
                $this.find('img').remove();
            }
        })
    }

    initCkEditor() {
        $('[data-ckeditor-name]').each((i, el) => {
            let name = $(el).data('ckeditor-name');

            if (typeof this.editors[name] === 'undefined') {

                CKEDITOR.ClassicEditor
                    .create(document.querySelector('#' + name), {
                        sourceElement: el,
                        toolbar: {
                            items: [
                                'undo', 'redo',
                                '|', 'heading',
                                '|', 'bold', 'italic',
                                '|', 'link', /*'SourceEditing',*/
                                '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                            ]
                        },
                        htmlSupport: {
                            allow: [
                                {
                                    name: /.*/, // Povolit všechny názvy elementů
                                    attributes: true, // Povolit všechny atributy
                                    classes: true, // Povolit všechny třídy
                                    styles: true // Povolit všechny styly
                                }
                            ]
                        }
                    })
                    .then(editor => {
                        editor.model.document.on('change', () => {
                            this.onTextAreaType(editor.sourceElement);
                        });
                        this.editors[name] = editor;
                    })
                    .catch(error => {
                        console.error(error.stack);
                    });
            }
        });
    }

    onApproveClick(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $this.hide();
        $this.append('<img width="15" height="15" src="/images/ajax-loader.gif" />');
        let lock = $this.closest('[data-item-card]').find('[data-approve-lock]').is(':checked');
        let url = $this.attr('href') + '?lock=' + (lock ? '1' : '0');

        $.ajax({
            url: url,
            type: 'GET',
            success: (response) => {
                if (response.status === 'error') {
                    this.alertModal.show(response.message, 'Error');
                    $this.show();
                } else {
                    alert(response.message);
                    $this.closest('[data-item-card]').slideUp(400, (e) => {
                        $this.closest('[data-item-card]').remove();
                        this.checkLastItemApproved();
                    });
                }
            }, complete: () => {
                $this.find('img').remove();
            }
        })
    }

    checkLastItemApproved() {
        if ($('[data-item-card]').length === 0) {
            $('[data-ajax-content-selector].' + this.classSelected).trigger('click');
        }
    }

    onPaginatorLinkClick(e) {
        e.preventDefault();
        let href = $(e.currentTarget).attr('href');
        $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').attr('href', href);
        this.synchronizeFilterHash(href);
        $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').trigger('click');
    }

    onPageLimitBtnClick(e) {
        e.preventDefault();
        let href = $(e.currentTarget).data('href');
        href = href + (href.indexOf('?') !== false ? '&' : '?') + 'limit=' + $(e.currentTarget).data('listPageLimit');
        $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').attr('href', href);
        this.synchronizeFilterHash(href);
        $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').trigger('click');
    }

    onFilteredValuesClick(e) {
        e.preventDefault();
        let href = $(e.currentTarget).attr('href');
        $.ajax({
            url: href,
            type: 'GET',
            success: (response) => {
                if (response.url) {
                    $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').attr('href', response.url);
                    this.synchronizeFilterHash(response.url);
                }
                $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').trigger('click');
            }
        })
    }

    synchronizeFilterHash(url) {
        let responseUrl = new URL(url);
        let paramFilterHash = responseUrl.searchParams.get('filter_hash');
        if (url.indexOf('urls') !== -1 || url.indexOf('goods') !== -1) {
            $('a[data-ajax-content-selector="products"]').each((e, elm) => {
                let $elm = $(elm);
                let from = $elm.data('fromUrl');
                let to = $elm.data('toUrl');
                let href = $elm.attr('href');
                let urlCurrent = new URL(href);
                if (paramFilterHash) {
                    urlCurrent.searchParams.set('filter_hash', paramFilterHash);
                } else {
                    urlCurrent.searchParams.delete('filter_hash');
                }
                let newUrl = urlCurrent.toString().replace(from, to);
                $elm.attr('href', newUrl);
            })

        }
    }

    onFilterSubmit(e) {
        e.preventDefault();
        let btn = e.originalEvent ? $(e.originalEvent.submitter) : '';

        let data = $(e.currentTarget).serializeArray();
        if (btn && btn.attr('name') !== 'send') {
            data.push({name: btn.attr('name'), value: 1});
        }

        $.ajax({
            url: $(e.currentTarget).attr('action'),
            type: 'POST',
            data: data,
            success: (response) => {
                $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').attr('href', response.url);
                this.synchronizeFilterHash(response.url);
                $('a[data-ajax-content-selector].Polaris-Tabs__Tab--active').trigger('click');
            }
        })
    }

    onUpdatePhraseSubmit(e) {
        e.preventDefault();
        let data = $(e.currentTarget).serialize();
        $.ajax({
            url: $(e.currentTarget).attr('action'),
            type: 'POST',
            data: data,
            success: (response) => {
                $('.action-modal').modal('hide');
                if (response.status === 'error') {
                    this.alertModal.show(response.message, 'Error');
                } else {
                    $('[data-phrase-unique-id="' + response.data.phraseUniqueId + '"]').html(response.data.phrase);
                    this.clearCacheForItem($('[data-phrase-unique-id="' + response.data.phraseUniqueId + '"]').closest('[data-product-check-item]'));
                }
            }
        })
    }

    clearCacheForItem(item) {
        let url = item.data('product-check-item');
        if (!url || url.indexOf('item-product') === -1) {
            return; // pouze pro produkty, ktere maji cache
        }
        url = url.replace('item-product', 'item-product-clear-cache');
        $.ajax({url: url}); // jen pingneme, nic vic
    }

    onChangeContent(e) {
        e.preventDefault();
        this.abortActiveRequests();

        let $this = $(e.currentTarget);
        let $tablist = $this.closest('ul');
        let loaderDescription = $this.data('loader-description') ? $this.data('loader-description') : '';
        $('.content-loading #loader-description').text(loaderDescription);
        this.$content.html($('.content-loading').html());

        let ajaxRequest = $.ajax({
            url: $this.attr('href'),
            type: 'GET',
            success: (data) => {
                this.$content.html(data.html);
                $('[data-filter-content]').replaceWith(data.filter);
                $('[data-filtered-values]').html(data.filteredValues);
                $('[data-sort]').replaceWith(data.sort);
                this.loadItems('data-product-check-item');
                this.loadItems('data-option-check-item');
            },
            error: (jqXHR, textStatus, errorThrown) => {
                this.$content.html(this.alert.danger('Chyba načtení obsahu'));
            },
            complete: () => {
                this.removeFromActiveRequests(ajaxRequest);
                $tablist.find('a').removeClass(this.classSelected);
                $this.addClass(this.classSelected);
                $('.content-loading #loader-description').text('');
            }
        });
        this.activeRequests.push(ajaxRequest);
    }

    loadItems(dataName) {
        let i = 50;
        $('[' + dataName + ']').each((index, item) => {
            $(item).html($('.content-loading').html());
            window.setTimeout(() => {
                this.loadOneItem(dataName, item);

            }, i += 50);
        });
    }

    reloadOneItem(e) {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let dataName = $this.data('dataName');
        let item = $this.closest('[' + dataName + ']');
        this.loadOneItem(dataName, item, true);
    }

    loadOneItem(dataName, item, t = false) {
        if(!dataName) return ;
        let ajaxRequest = $.ajax({
            url: $(item).data(dataName.replace('data-', '')),
            type: 'GET',
            success: (data) => {
                $(item).html(data.html);
            },
            complete: () => {
                this.removeFromActiveRequests(ajaxRequest);
            }, error: (jqXHR, textStatus, errorThrown) => {
                $(item).html(this.alert.danger('Chyba načtení obsahu <a href="#" data-reload-item>Zkusit znovu</a>'));
                $(item).find('a[data-reload-item]').data('dataName', dataName);
            }
        });
        this.activeRequests.push(ajaxRequest);
    }

    removeFromActiveRequests(ajaxRequest = null) {
        if (ajaxRequest) {
            let index = this.activeRequests.indexOf(ajaxRequest);
            if (index !== -1) {
                this.activeRequests.splice(index, 1);
            }
        }
    }

    abortActiveRequests() {
        this.activeRequests.forEach((request) => {
            request.abort();
        });
        this.activeRequests = [];
    }

    onSortClick(e) {
        e.preventDefault();
        $('[data-list-filter] input[name="sort"]').val($(e.currentTarget).data('sortValue'));
        $('[data-list-filter]').trigger('submit');
    }
}
